import type { SupportedLocale } from '@/lib/utils/localization/getFlattenedLocales'
import { getCosmicTopMarqueeBanner } from './cosmic/fetchFunctions/getCosmicTopMarqueeBanner'
import type { CMSResult } from './types/CMSError'
import { logError } from '../utils/shared/log'

export type GetTopMarqueeBannerProps = {
  locale: SupportedLocale
  isNfrUser: boolean
  signal?: AbortSignal
}

export const getTopMarqueeBanner = async ({
  locale,
  isNfrUser,
  signal,
}: GetTopMarqueeBannerProps): Promise<CMSResult<
  ReturnType<typeof getCosmicTopMarqueeBanner>
> | null> => {
  try {
    const topMarqueeBanner = await getCosmicTopMarqueeBanner({
      locale,
      isNfrUser,
      signal,
    })

    if (!topMarqueeBanner) {
      return {
        error: {
          code: 'COSMIC_MARQUEE_DATA_MISSING',
          message:
            'Some announcements are temporarily unavailable. You can continue shopping normally.',
          source: 'cosmic',
          timestamp: new Date().toISOString(),
        },
      }
    }

    return topMarqueeBanner
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error)
    const errorDetails = {
      code: 'COSMIC_MARQUEE_FETCH_FAILED',
      message:
        "We're having trouble loading our latest announcements. Please check back later.",
      source: 'cosmic' as const,
      details: errorMessage,
      timestamp: new Date().toISOString(),
    }

    logError(
      'COSMIC: Unable to get topMarqueeBanner cosmic data:',
      errorDetails,
    )
    return { error: errorDetails }
  }
}
